module.exports = __webpack_public_path__ + "static/media/PICT0018-2(1)-01.3683f166.jpg";